import { render, staticRenderFns } from "./WriteupComponent.vue?vue&type=template&id=4ef20b82&"
import script from "./WriteupComponent.vue?vue&type=script&lang=js&"
export * from "./WriteupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports